import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./AuthProvider";
export function ProtectedRoute() {
  const { authenticated, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="route-skeleton" aria-busy="true" />;
  return authenticated ? (
    <Outlet />
  ) : (
    <Navigate to="/login" replace state={{ from: location.pathname }} />
  );
}
